import {ucFirst} from "./string";

/**
 * Checks if {val} is of type {type}
 * @param val
 * @param type
 * @returns {boolean}
 */
export function is(val, type) {
    return Object.prototype.toString.call(val) === `[object ${ucFirst(type)}]`;
}

/**
 * Checks if {val} is an array
 * @param val
 * @returns {boolean}
 */
export function is_array(val) {
    return is(val, "array");
}

/**
 * Checks if {val} is an object
 * @param val
 * @returns {boolean}
 */
export function is_object(val) {
    return is(val, "object");
}

/**
 * Checks if val is a string
 * @param val
 * @return {boolean}
 */
export function is_string(val) {
    return is(val, "string");
}

/**
 * Checks if val is a function
 * @param val
 * @return {boolean}
 */
export function is_function(val) {
    return is(val, "function");
}
